
<div class="position-relative py-96r">

    <div class="position-absolute w-100 h-100 top-0 start-0 container-fluid background-cover bg-back"  [ngStyle]="{'background-image': useImage ? 'url(' + urlImage + ')' : 'none'}">
    </div>

    <ng-content></ng-content>

</div>